/**
 * The order every host shows diagnostics in, and the merge of a file's own diagnostics with the cross-file ones a
 * `LintSession` reads later. `Linter` and the session sort through it, so every host shows one order.
 */
import { SEVERITY_ORDER, flooredSeverity } from './types.js';
/**
 * `diagnostics` sorted by severity, errors first, in place, an unranked tier floored to `info`. A bare index gives
 * `undefined` for a severity outside the union, and the `NaN` difference reads as "equal", leaving the order undecided.
 * The sort is stable, so the order within a tier stays.
 */
export function sortDiagnostics(diagnostics) {
    return diagnostics.sort((a, b) => SEVERITY_ORDER[flooredSeverity(a.severity)] - SEVERITY_ORDER[flooredSeverity(b.severity)]);
}
/** A new list of `local` and `crossFile` together, sorted by severity. Neither input changes. */
export function mergeDiagnostics(local, crossFile) {
    return sortDiagnostics(local.concat(crossFile));
}
//# sourceMappingURL=mergeDiagnostics.js.map